export default __webpack_public_path__ + "static/ux-strategy-1--ca63cbbbf98873cc0656d6da91b033a1.png";